import jwt_decode from "jwt-decode";
import {setStore, getStore, removeStore} from '../config/mUtils'
import store from "../store/index";

export default async () => {

    let TOKEN = getStore('NameAppUserToken');
    if (TOKEN == '' && TOKEN == null) {
        return Promise.reject(false);
    } else {
        let decoded = jwt_decode(TOKEN);
        if (decoded.exp > Date.now() / 1000) {
            // 時間內

            // console.log(store.state.login+"*****")
            if (store.state.login) {
                return Promise.resolve(true);
            } else {
                try {
                    let res = await store.dispatch('actionRefreshToken')
                    return Promise.resolve(res);
                } catch (e) {
                    return Promise.reject(e);
                }
            }
        } else {
            return Promise.reject(false);
        }


    }


}
